import { render } from "./dishes.vue?vue&type=template&id=441ef999&scoped=true"
import script from "./dishes.vue?vue&type=script&lang=js"
export * from "./dishes.vue?vue&type=script&lang=js"

import "./dishes.vue?vue&type=style&index=0&id=441ef999&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\resturant2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441ef999"]])

export default __exports__